
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/gong",
      function () {
        return require("private-next-pages/destinations/gong.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/gong"])
      });
    }
  